/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeForwardIcon24Solid = forwardRef('ArrowRoundTimeForwardIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M15.825 5.26a7.75 7.75 0 1 0 3.258 9.886 1.25 1.25 0 1 1 2.285 1.015A10.25 10.25 0 1 1 19.75 5.29V3.038a1.25 1.25 0 1 1 2.5 0v5.754A1.25 1.25 0 0 1 21 10.04h-5.5a1.25 1.25 0 0 1 0-2.5h2.838a7.75 7.75 0 0 0-2.513-2.281Z" })));
});
